export enum CollageSizeEnum {
  Size1 = '1024x768',
  Size2 = '1080x1080',
  Size3 = '1080x1350',
  Size4 = '1600x900',
  Size5 = '1920x1080'
}
